import React from "react";

const NeueItalicStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 2.75H9.75M12 2.75H14.25M12 2.75L8 17.25M8 17.25H5.75M8 17.25H10.25",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(NeueItalicStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;